<template>
  <BaseLayout theme-footer="standard">
    <slot />
  </BaseLayout>
</template>

<script setup lang="ts">
import BaseLayout from '~/components/base-layout.vue';
</script>
